<template>

    <div class="Header cadfm-flexitem-fixed">
        <b-navbar v-if="isLogged" toggleable="sm" :type="s_skinVariant" :variant="s_skinVariant" >

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>


        <b-navbar-brand>
          <img v-if="s_skinVariant == 'dark'" src="/static/OMNYA-integration-platform-dark.svg">
          <img v-if="s_skinVariant == 'light'" src="/static/OMNYA-integration-platform-light.svg">
          
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <router-link v-if="appConf.status.isPM" to="/Dashboard/DashboardWidgets" class="nav-link">{{lang["Dashboard"]}}</router-link>
            <router-link v-if="appConf.status.isPM" @click.native="reloadTable()" to="/PartManager/PartTable" class="nav-link">{{lang["Parts"]}}</router-link>
            
            <!-- <router-link to="/ProcessesManager/ProcessesTable" class="nav-link">{{lang["Processes"]}}</router-link> -->
            <router-link v-if="appConf.status.isLM" @click.native="reloadTable()" to="/LibraryManager/LibraryTable" class="nav-link">{{lang["Libraries"]}}</router-link>
            
            <router-link v-if="appConf.status.isPRM" @click.native="reloadTable()" to="/ProjectManager/ProjectTable" class="nav-link">{{lang["Projects"]}}</router-link>
            <router-link  to="/Users/Main" class="nav-link">{{lang["Users"]}}</router-link>
            <router-link to="/Settings/Main" class="nav-link">{{lang["Settings"]}}</router-link>
            <router-link to="/About/Main" class="nav-link">{{lang["About"]}}</router-link>
            
            

          </b-navbar-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

              <div class="mb-1 avatar">
                <b-avatar v-b-tooltip.hover.left :title="'login: ' + currentUser.login + ' role: ' + currentUser.role" v-if="currentUser.role=='Admin'" variant="danger" size="sm"></b-avatar>
                <b-avatar v-b-tooltip.hover.left :title="'login: ' + currentUser.login + ' role: ' + currentUser.role" v-if="currentUser.role!='Admin'" size="sm"></b-avatar>
                {{fullName}}
              </div>



            <!--<b-button v-b-tooltip.hover.left :title="lang.button_Settings" v-on:click="settings" size="sm" class="my-2 my-sm-0" type="submit">{{lang.button_Settings}}</b-button>-->
            <b-button v-b-tooltip.hover.left :title="lang.button_Logout" v-on:click="logout" :variant="variant" size="sm" class="my-2 my-sm-0" type="submit">{{lang.button_Logout}}</b-button>

          </b-navbar-nav>



        </b-collapse>
      </b-navbar>
      <b-navbar v-if="!isLogged" toggleable="md" :type="s_skinVariant" :variant="s_skinVariant">

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>



        <b-navbar-brand>
          <img v-if="s_skinVariant == 'dark'" src="/static/OMNYA-integration-platform-dark.svg">
          <img v-if="s_skinVariant == 'light'" src="/static/OMNYA-integration-platform-light.svg">
          
        </b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <img v-if="s_skinVariant == 'dark'" src="/static/FlowCAD-Logo-dark.svg">
            <img v-if="s_skinVariant == 'light'" src="/static/FlowCAD-Logo-light.svg">
          </b-navbar-nav> -->

      </b-navbar>

      <!-- <SettingsComponent></SettingsComponent> -->
    </div>





</template>
<script>
  //import SettingsComponent from "@/components/shared/SettingsComponent"
  import { mapGetters } from 'vuex'

  export default {
    name: 'Header',
    components: {
      //SettingsComponent
    },
    data () {
      return {
        fullName: ""
      }
    },
    props: {
      lang: Object
    },
    computed: {
      ...mapGetters([
      'isLogged',
      'isSettings',
      's_skinVariant',
      'appConf',
      'isPlugin'
      ]),
      currentUser(){
        return this.$store.getters.currentUser;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      }
    },
    created(){
      this.getUser();    
    },
    updated() {

      this.getUser();
    },
    
    methods: {
      getUser(){
        let vue = this;

        const obj = {
          userId: this.currentUser.userId
        }
        
        this.$store.dispatch("u_getUser", obj)
        .then ((result) => {

          
          if (result.data != null){
            if (result.data.length > 0){
              vue.fullName = result.data[0].FirstName + " " + result.data[0].LastName;

              vue.$store.dispatch("setUserFullName", vue.fullName);
            }
          }
          
          
          

        })
      },
      logout(){
        this.$store.dispatch('logout');
      },
      reloadTable() {

        let reloadObj = {};
        if (this.$store.getters.sectionPrefix == "pm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiComponent";

        }
        if (this.$store.getters.sectionPrefix == "lm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiLibComponent"
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          this.$store.dispatch("deleteAllSelectedRows");
          reloadObj.status = true;
          reloadObj.name = "DataTableFilteredOnApiProjComponent"
        }
        
        this.$store.dispatch("reloadAfterAction", reloadObj);
        
        this.$store.dispatch("setSaveStatus", false);
      }
    },
    watch: {
      currentUser: function(newVal, oldVal){
        
        this.login = newVal
      }
    }
  }
</script>
<style lang="scss">

  @import "./../scss/_theme.scss";

  .Header{

    .image-desc {
      font-size: 0.6rem;
      float:left;
      display: block;
    }
    .navbar-brand {
      margin-left: 1rem;
      
    }
    .navbar-brand img{
      height:38px;
      
    }
    img{
      margin-right: 0px;
      margin-left: 0px;
      height: 22px;
      display: block
    }
    button{
      margin-right: 10px;
    }

    .avatar{
      margin-right: 10px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue